import { isNumber, once } from 'lodash-es'

export const OptimizedLatLng = once(
  () =>
    class OptimizedLatLng extends window.google.maps.LatLng {
      private _lat: number
      private _lng: number

      constructor(pos: number | google.maps.LatLngLiteral | google.maps.LatLng) {
        super({ lat: 0, lng: 0 })
        //These are needed to process the position from a google.maps.Marker which can be a number, a LatLngLiteral or a LatLng
        //The 0 fallback is an absolute last resort, but it is handled downstream
        this._lat = isNumber(pos)
          ? pos
          : isNumber(pos.lat)
            ? pos.lat
            : typeof pos.lat === 'function'
              ? pos.lat()
              : 0
        this._lng = isNumber(pos)
          ? pos
          : isNumber(pos.lng)
            ? pos.lng
            : typeof pos.lng === 'function'
              ? pos.lng()
              : 0
        this.lat = () => this._lat
        this.lng = () => this._lng
      }

      get latitude() {
        return this._lat
      }

      set latitude(lat: number) {
        this._lat = lat
      }

      get longitude() {
        return this._lng
      }

      set longitude(lng: number) {
        this._lng = lng
      }

      toJSON() {
        return { lat: this._lat, lng: this._lng }
      }
    },
)

let MLL = undefined
/** This is a hook because it can only be used when the window object is available and google maps is loaded */
export const useOptimizedLatLng: typeof OptimizedLatLng = () => {
  // This because we don't want to make the GC cry
  // https://github.com/tweenjs/tween.js/blob/main/docs/user_guide.md#be-good-to-the-garbage-collector-alias-the-gc
  MLL ||= OptimizedLatLng()
  return MLL
}
